import axios from 'axios';

import { fdApiUse } from '../apiUtils';
import {
  AddUserPayGreenVoucher,
  CategorizedMenuItemsResponse,
  GetUserSavedRestaurantVouchersQueryParams,
  GetUserSavedRestaurantVoucherStatusQueryParams,
  PostAddUserPayGreenVoucherRequestPayload,
  PostCategorizeMenuitemsRequestPayload,
  SavedRestaurantVoucher,
  UserSavedRestaurantVouchers,
} from './payment.types';

// #region get requests
export const getUserSavedRestaurantVouchers = (
  queryParams: GetUserSavedRestaurantVouchersQueryParams,
): Promise<UserSavedRestaurantVouchers> =>
  fdApiUse(
    axios.get('/RestaurantVouchers/GetUserSavedRestaurantVouchers', {
      params: queryParams,
    }),
  ).then((data: UserSavedRestaurantVouchers) => data);

export const getUserSavedRestaurantVoucherStatus = (
  queryParams: GetUserSavedRestaurantVoucherStatusQueryParams,
): Promise<SavedRestaurantVoucher> =>
  fdApiUse(
    axios.get('/RestaurantVouchers/GetUserSavedRestaurantVoucherStatus', {
      params: queryParams,
    }),
  ).then((data: SavedRestaurantVoucher) => data);
// #endregion

// #region post requests
export const postAddUserPayGreenVoucher = (
  requestPayload: PostAddUserPayGreenVoucherRequestPayload,
): Promise<AddUserPayGreenVoucher> =>
  fdApiUse(
    axios.post('/RestaurantVouchers/AddUserPayGreenVoucher', requestPayload),
  ).then((data: AddUserPayGreenVoucher) => data);

export const postCategorizeMenuitems = (
  requestPayload: PostCategorizeMenuitemsRequestPayload,
): Promise<CategorizedMenuItemsResponse> =>
  fdApiUse(axios.post('/Checkout/CategorizeMenuitems', requestPayload)).then(
    (data: CategorizedMenuItemsResponse) => data,
  );
// #endregion
